import NavBar from '../components/NavBar'
import HeroSection from '../components/DataCleaningMigration/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/DataCleaningMigration/ProcessSection'
import TechStackMarquee from '../components/DataCleaningMigration/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const DataCleaningMigration = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default DataCleaningMigration